<template>
  <div>
    <h1>Core protect-opas</h1>
    <h2>kesken!</h2>
    <p>Jafarinin käsialaa</p>
    <p>Coreprotection kerää tietokantaan kaikki serverin tapahtumat, niin pelaajien, mobien ja jopa “luonnon” tapahtumat. Tätä tietokantaa luetaan käyttäen /coreprotection tai /co komentoa ja yleisin käyttökohde core-suojauksen kanssa on palikan tai itemin tapahtumien tutkiminen.</p>
    <h2>core inspection (co i)</h2>
    <p>
      Kyseinen /co inspection (/co i) komento on käytössä myös pelaajilla
      <u>Nekromantikko-rankista</u> alkaen. Komento antaa käyttöön tapahtuma listan mitä voi selata käyttäen komentoa <Command command="co" params="lookup &lt;sivunro&gt;"/>
       Käytössä pitää erottaa minkä blockin tiedot saa klikkaamalla työkalulla tai blokilla. Työkalulla saa klikatun blokin tiedot, kun taas blockilla sen blockin mihin kyseinen blokki olisi jäänyt, eli tyhjän paikan kohdan tiedot.
    </p>
    <h2>core lookup (co l)</h2>
    <p>Lookup toiminto on tehokas keino hakea tietoja serverillä tehdyistä asioista. Se paljastaa tapahtumien aiheuttajan ja ajan.</p>
    <Command command="co" params="user:&lt;pelaaja&gt; action:&lt;teko&gt; time:&lt;aika&gt; radius:&lt;etäisyys&gt; block:&lt;kohde&gt; exclude:&lt;ei listattava kohde&gt;" desc="" example="" />

    <p>
      <Command command="co" params="l u:&lt;pelaaja&gt; a:&lt;teko&gt; t:&lt;aika&gt; r:&lt;etäisyys&gt; b:&lt;kohde&gt; e:&lt;ei listattava kohde&gt;" desc="" example="" />
      /co poikkeuksena /co l -komennon käyttöön on kun halutaan lukea pitkästä coreprotection hakutuloksesta muita sivuja, kuin ensimmäinen esim /co l 13, joka näyttää kolmannentoista sivun viimeisimmän /co i tai /co l -haun tuloksesta.
    </p>

    <p>Kaikkia parametreja ei tarvitse käyttää. Jättämällä pois pelaajan nimi pois, saadaan kaikkien tekijöiden (myös mobien) aiheuttamat tapahtumat listattua.</p>
    <p>
      <strong>u:&lt;pelaaja&gt;</strong> - Pelaajan nimi tulee olla minen nimi, ei muutettu nickki. Mikäli halutaan nähdä määrätyn mobin tai luonnon ilmiön aiheuttama tapahtuma käytetään sen edessä #-merkkiä, esim #creeper, #water, #fire ja #zombie.
    </p>

    <p>
      <strong>a:&lt;tapahtuma&gt;</strong> - listataan vain määrätynlaiset tekemiset/tapahtumat. Esimerkiksi jos haluaa nähdä vain asetetut blockit käytetään parametriä a:+block
    </p>

    <p>
      <strong>action - tapahtumat</strong>
    </p>
    <Command params="a:block" desc="(asetetut ja poistetut blockit)" example=""/>
    <Command params="a:item" desc="(tavaralle tapahtuneet tapahtumat)" example=""/>
    <Command params="a:+block" desc="(blokin asettaminen)" example=""/>
    <Command params="a:+item" desc="(tavaran poiminen maasta tai laitto arkkuun)" example=""/>
    <Command params="a:-block" desc="(blokin poistaminen)" example=""/>
    <Command params="a:-item" desc="(tavaran pudottaminen tai arkusta otto)" example=""/>
    <Command params="a:chat" desc="(chatissä lähetetyt viestit)" example=""/>
    <Command params="a:kill" desc="(mobin, eläimen tai pelaajan kuolema)" example=""/>
    <Command params="a:click" desc="(pelaajien klikkaukset)" example=""/>
    <Command params="a:session" desc="(pelaajan sisään tai ulos kirjautumiset)" example=""/>
    <Command params="a:command" desc="(annetut komennot)" example=""/>
    <Command params="a:+session" desc="(pelaajan liittyminen palvelimelle)" example=""/>
    <Command params="a:container" desc="(arkkujen käsittely)" example=""/>
    <Command params="a:-session" desc="(pelaajan poistuminen palvelimelta)" example=""/>
    <Command params="a:+container" desc="(arkkuihin laitot)" example=""/>
    <Command params="a:sign" desc="(kyltteihin kirjoittamiset)" example=""/>
    <Command params="a:-container" desc="(arkuista ottamiset)" example=""/>
    <Command params="a:username" desc="(pelaajanimen vaihtamiset)" example=""/>
    <Command params="a:inventory" desc=" (pelaajan inventorin tapahtumat)" example=""/>
    <Command params="a:+inventory" desc="(pelaajan maasta otetut tavarat)" example=""/>
    <Command params="a:-inventory" desc="(pelaajan pudottamat tavarat)" example=""/>

    <p>
      <strong>t:&lt;aika&gt;</strong> - Määrittelee ajan miltä ajalta komento hakee tapahtumatietoja tietokannasta. Aikamääreitä voivat olla w-viikko, d-päivä, h-tunnit, m-minuutit ja s-sekunnit, esim 2w, 5d,6h,2m,10s
    </p>
    <p>t:5d, t:4d2h tai t:2.25h (2 tuntia ja 15 minuuttia)</p>

    <p>
      <strong>r:&lt;radius&gt;</strong> - /co -komennon vaikutusalue.
    </p>
    <p>Etäisyys voi olla numerona (esim r:10), maailma (esim r:#word_the_end), globaali (r:#global) tai WorldEdit valinta (r:#worldedit tai r:#we).</p>

    <p>
      <strong>b:&lt;blokit&gt;</strong>- käsitellään vain valittua blokki tyyppiä tai tyyppejä
    </p>
    <p>
      Mikäli haluat käsitellä vain stoneja, niin käytä parametriä b:1
      Voit käyttää useampaa blokkia erottamalla ne pilkulla, kuten b:1,5,7
    </p>

    <p>
      Lista blokki tyyppien ID:stä löytyy seuraavasta linkistä:
      <u>Data value</u> 🔗
    </p>

    <p>
      <strong>e:&lt;exclude&gt;</strong> - Exclude certain block types from the rollback.
    </p>
    <p>For example, if you don't want TNT to come back during a rollback, you would type e:46</p>

    <h2>core rollback</h2>
    <p>Rollaaminen on erittäin riskialtista toimintaa, joten kyseisen komennon kanssa tulee olla erittäin varovainen. Ensimmäinen asia mikä tulee tarkistaa ennen komennon ajamista, onko kyseinen tapaus oikeasti rollattava ja että palautettava alue ei ole liian laaja.</p>
    <h2>core vinkit:</h2>

    <p>Onko 100 ruudun sisällä kukaan pelaajista klikannut mitään</p>
    <p>/co l t:30d r:100 a:click</p>
  </div>
</template>

<script>
import Command from '@/components/Command'
export default {
  name: "coreprotect",
  components: {
    Command
  },
  metaInfo: {
    title: "Core Protect"
  }
};
</script>

<style scoped></style>
